import AbsaLogo from "./assets/images/absa.svg";
import CapitecLogo from "./assets/images/capitec.svg";
import CardLogo from "./assets/images/card.svg";
import FBBSVG from "./assets/images/fnb-svg.svg";
import FNBLogo from "./assets/images/fnb.svg";
import FNBPayLogo from "./assets/images/FNB_Pay_logo.png";
import FNBScanToPaySVG from "./assets/images/fnb-scan-to-pay-svg.svg";
import InstantEFTLogo from "./assets/images/instant-eft.svg";
import MastercardLogo from "./assets/images/mc_symbol.svg";
import Masterpass from "./assets/images/masterpass.svg";
import MasterpassLogo from "./assets/images/Masterpass_mobile app.png";
import NedbankMoneyLogo from "./assets/images/nedbank-money.svg";
import NedbankMoneySVG from "./assets/images/nedbank-money-svg.svg";
import NedbankScanToPaySVG from "./assets/images/nedbank-scan-to-pay-svg.svg";
import { PaymentMethodModel } from "./models/paymentMethodModel";
import RMBLogo from "./assets/images/rmb.svg";
import SnapScanLogo from "./assets/images/snapscan.svg";
import SnapscanSVG from "./assets/images/snapscan-svg.svg";
import StandardBank from "./assets/images/standard-bank.png";
import StandardBankLogo from "./assets/images/standard.png";
import VisaLogo from "./assets/images/Visa_logo.jpg";
import Zapper from "./assets/images/zapper.svg";
import ZapperSVG from "./assets/images/zapper-svg.svg";

export const mobileMethods: PaymentMethodModel[] = [
  {
    name: "Card",
    thumbnails: [CardLogo],
  },
  {
    name: "EFT",
    thumbnails: [InstantEFTLogo],
  },
  {
    name: "Masterpass",
    thumbnails: [Masterpass],
  },
  {
    name: "FNB",
    thumbnails: [FBBSVG],
  },
  {
    name: "Snapscan",
    thumbnails: [SnapscanSVG],
  },
  {
    name: "Zapper",
    thumbnails: [ZapperSVG],
  },
  {
    name: "Direct Bank Eft",
    thumbnails: [InstantEFTLogo],
  },
  {
    name: "Nedbank money",
    thumbnails: [NedbankMoneySVG],
  },
  {
    name: "Nedbank scan to pay",
    thumbnails: [NedbankScanToPaySVG],
  },
  {
    name: "fnb scan to pay",
    thumbnails: [FNBScanToPaySVG],
  },
  {
    name: "RMB scan to pay",
    thumbnails: [RMBLogo],
  },
  {
    name: "Capitec EFT",
    thumbnails: [CapitecLogo],
  },
];

export const webMethods: PaymentMethodModel[] = [
  {
    name: "Capitec",
    thumbnails: [CapitecLogo],
  },
  {
    name: "Debit / Credit Card",
    thumbnails: [VisaLogo, MastercardLogo],
  },
  {
    name: "Instant EFT",
    thumbnails: [
      AbsaLogo,
      FNBLogo,
      StandardBank,
      NedbankMoneyLogo,
      CapitecLogo,
    ],
  },
  {
    name: "Scan to Pay",
    thumbnails: [
      MasterpassLogo,
      NedbankMoneyLogo,
      FNBPayLogo,
      SnapScanLogo,
      Zapper,
    ],
  },
  {
    name: "FNB Pay Ecommerce",

    thumbnails: [FNBPayLogo],
  },
  {
    name: "Direct Bank EFT",
    thumbnails: [AbsaLogo, FNBLogo, CapitecLogo, RMBLogo],
  },
];
